import { useCallback } from 'react';
import { UiKitButton } from '@components/common/ui-kit-button';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
export const ButtonClose = ({
  eventName
}: {
  eventName?: string;
}) => {
  const {
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleClick = useCallback(() => {
    if (eventName) {
      trackUnsubscribeEvent(eventName);
    }
    closeWebView();
  }, [eventName, trackUnsubscribeEvent]);
  return <UiKitButton color="secondary" onClick={handleClick} data-sentry-element="UiKitButton" data-sentry-component="ButtonClose" data-sentry-source-file="index.tsx">
      Done
    </UiKitButton>;
};